import useSWRImmutable from "swr/immutable"

import { AppError } from "../../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../../errors/recognisedErrors"
import { getTsIoMapper } from "../../../../../utils/general/generalUtils"
import { getClientProtected } from "../../../clients/clients"
import { CONTINUE_DRAFT_CONFIG } from "../../../swrConfig"
import {
    ContinueDraftResponse,
    TContinueDraftResponse,
} from "../../../types/devices/ttr/publishDeviceTypes"
import { CONTINUE_DEVICE_DRAFT } from "../../../urls/private"

interface IUseContinueDeviceDraftOutput {
    data?: TContinueDraftResponse
    isLoading: boolean
    isValidating: boolean
    error?: AppError
}

const continueDeviceDraftMapper = getTsIoMapper(
    ContinueDraftResponse,
    "continueDeviceDraftMapper"
)

const useContinueDeviceDraft = (
    deviceRef: string
): IUseContinueDeviceDraftOutput => {
    const { data, error, isLoading, isValidating } = useSWRImmutable(
        CONTINUE_DEVICE_DRAFT(deviceRef),
        async (url: string): Promise<TContinueDraftResponse> => {
            try {
                const response = await getClientProtected(url)
                return continueDeviceDraftMapper.map(response)
            } catch {
                throw invalidApiDataError("Failed to continue draft version")
            }
        },
        CONTINUE_DRAFT_CONFIG
    )

    return {
        data,
        isLoading,
        isValidating,
        error,
    }
}

export default useContinueDeviceDraft
